import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-investigation',
  templateUrl: './investigation.component.html'
})
export class InvestigationComponent implements OnInit {
  constructor() {
  }

  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/investigation/investigation.component.ts